/* eslint-disable max-len */
/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 * */

/**
 * NoCoursesEmptyStateIcon Icon
 *
 * @file NoCoursesEmptyStateIcon.jsx
 * @author Anuja Gaikwad
 * @since 1.5.5
 */

import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import PropType from 'prop-types';

const NoCoursesEmptyStateIcon = ({ className }) => (
  <SvgIcon className={className} xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
    <path d="M33.4675 19.216L20.4235 6.17602C20.1875 5.94002 19.8075 5.94002 19.5755 6.17602L6.53147 19.216C6.41947 19.328 6.35547 19.48 6.35547 19.64V30.928C6.35547 32.62 7.73147 34 9.42747 34H30.5715C32.2635 34 33.6435 32.624 33.6435 30.928V19.64C33.6435 19.48 33.5795 19.328 33.4675 19.216ZM32.4395 30.928C32.4395 31.96 31.5995 32.796 30.5715 32.796H23.5235V24.94C23.5235 22.996 21.9475 21.416 19.9995 21.416C18.0515 21.416 16.4755 22.992 16.4755 24.94V32.796H9.42747C8.39547 32.796 7.55947 31.956 7.55947 30.928V19.888L19.9995 7.44802L32.4395 19.888V30.928Z" fill="currentColor" />
  </SvgIcon>
);

NoCoursesEmptyStateIcon.propTypes = {
  className: PropType.string.isRequired
};

export default NoCoursesEmptyStateIcon;

